export default "__VITE_ASSET__BfjKOjhr__"